import { ReactElement, useContext, useState } from "react";
import { Badge, IconButton } from "@justworkshr/milo-core";
import { CheckboxInput } from "@justworkshr/milo-form";
import ToggleMfaStepContext from "../../contexts/ToggleMfaStepContext";

import styles from "./non-production-banner.module.css";
import { getEnvironmentName } from "../../lib/environment";

const NonProductionBanner = (): ReactElement => {
  const { toggleMfaStep } = useContext(ToggleMfaStepContext);
  const [bannerHidden, setBannerHidden] = useState(false);

  return (
    <div className={`${bannerHidden ? styles.hidden : styles.container}`}>
      <Badge className={styles.badge}>
        {getEnvironmentName().toUpperCase()}
      </Badge>

      {getEnvironmentName() !== "tour" && (
        <div className={styles.rightSide}>
          <CheckboxInput
            value={"mfaEnabled"}
            name={"mfa-toggle"}
            label={"Enable MFA step"}
            onChange={toggleMfaStep}
          />
          <div className={styles.closeButton}>
            <IconButton
              size="sm"
              variant="ghost"
              color="inverse"
              iconName={"close"}
              title={"hide"}
              onClick={() => setBannerHidden(!bannerHidden)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default NonProductionBanner;
